import { GroupBox } from 'react95';
import React from 'react';

import './ContentBlock.scss';

export const ContentBlock = ({title, children}) => (
  <GroupBox className="content-block" label={<h2 className="content-block__title">{title}</h2>}>
    {children}
  </GroupBox>
);